import styled from "@emotion/styled";
export const BrowserCrumbsRoot = styled.div`
  display: flex;
  align-items: center;
`;
export const BrowserCrumbsItem = styled.div`
  display: flex;
  align-items: center;
`;
